import api from '../api/user-api';
export default {
  getUserInfo (url, param) {
    return new Promise((resolve, reject) => {
      api.getUserInfo(url, param).then(({ data }) => {
          if (data.code === 200) {
              resolve(data.result || {});
          } else {
              reject(data);
          }
      });
  });
  },
  editUserInfo (param) {
    return new Promise((resolve, reject) => {
      api.editUserInfo(param).then(({ data }) => {
          if (data.code === 200) {
              resolve(data.result || {});
          } else {
              reject(data);
          }
      });
    });
  },
  addUser (param) {
    return new Promise((resolve, reject) => {
      api.addUser(param).then(({ data }) => {
          if (data.code === 200) {
              resolve(data.result || {});
          } else {
              reject(data);
          }
      });
    });
  },
  delUser (param) {
    return new Promise((resolve, reject) => {
      api.delUser(param).then(({ data }) => {
          if (data.code === 200) {
              resolve(data.result || {});
          } else {
              reject(data);
          }
      });
    });
  },
    getProjectUsers(projectId) {
        return new Promise((resolve, reject) => {
            api.getProjectUsers(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    saveUserBatch(data, projectId) {
        return new Promise((resolve, reject) => {
            api.saveUserBatch(data, projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || []);
                } else {
                    reject(data);
                }
            });
        });
    },
    getProjectName (projectId) {
        return new Promise((resolve, reject) => {
            api.getProjectName(projectId).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getSystemAdminList () {
        return new Promise((resolve, reject) => {
            api.getSystemAdminList().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    delSystemAdminByEmail (email) {
        return new Promise((resolve, reject) => {
            api.delSystemAdminByEmail(email).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    addSystemAdmin (data) {
        return new Promise((resolve, reject) => {
            api.addSystemAdmin(data).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    saveUserFirstVisit(){
        return new Promise((resolve, reject) => {
            api.saveUserFirstVisit().then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    getByIds(ids){
        return new Promise((resolve, reject) => {
            api.getByIds(ids).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    },
    setTopProject(id){
        return new Promise((resolve, reject) => {
            api.setTopProject(id).then(({data}) => {
                if (data.code === 200) {
                    resolve(data.result || '');
                } else {
                    reject(data);
                }
            });
        });
    }
}